import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Routes } from '@angular/router';
import {
  filter,
  map,
  Observable
} from 'rxjs';
import { Roles } from '../../../../core';
import { AuthService } from '../shared/services/auth.service';
import { AccountComponent } from './account.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';

export const hasRole: (role: Roles, exact?: boolean) => () => boolean
  = (role: Roles, exact: boolean = false) => () => inject(AuthService).hasRole(role, exact);

export const isAuthCompleted: () => Observable<boolean> = () => toObservable(inject(AuthService).user)
  .pipe(
    filter(user => !!user),
    map(user => user!.authCompleted)
  );

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: 'auth',
    canMatch: [ isAuthCompleted ],
    component: AccountComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/'
  },
  {
    path: 'new',
    title: 'auth.signUp',
    component: SignUpComponent
  },
  {
    path: 'confirm-deletion/:token',
    title: 'confirmDeleteAccount',
    loadComponent: () => import('./confirm-deletion/confirm-deletion.component')
      .then(m => m.ConfirmDeletionComponent)
  },
  {
    path: 'sign-in',
    title: 'signIn',
    component: SignInComponent
  }
];
